import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import Cookies from 'js-cookie';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { map } from 'rxjs/operators';
import { PaginationRequest } from '../interfaces/pagination-request';
import { timeout, catchError } from 'rxjs/operators';

@Injectable()
export class LoanService {
    constructor(
        private http: HttpClient,
        private router: Router,
    ) { }

    getCookie(name) {
        return Cookies.get(name, {domain: environment.domain, path: environment.path});
    }

    removeSessionCookies() {
        Cookies.remove('csrftoken', {domain: environment.domain})
        Cookies.remove('sssLoanDashboardPagination', {domain: environment.domain, path: environment.path})
        Cookies.remove('isStaff', {domain: environment.domain})
        Cookies.remove('OLAP_UserGroup', {domain: environment.domain})
        Cookies.remove('reviewId', {domain: environment.domain})
        Cookies.remove('sessionid', {domain: environment.domain, path: environment.path})
        document.cookie = "csrftoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=" + environment.path + "; domain=" + environment.domain;
        document.cookie = "sessionid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=" + environment.path + "; domain=" + environment.domain;
    }

    getSssLoans(params: PaginationRequest): Observable<any> {
        const url = environment.apiUrl + 'sss-loan/'; // trailing slash needed (based from backend urls.py)

        const csrftoken: any = Cookies.get('csrftoken') ? Cookies.get('csrftoken') : null;

        let options = {
          withCredentials: true,
          headers: new HttpHeaders({
            'X-CSRFToken': csrftoken
          }),
          params: {
              recs_per_page: params.recs_per_page ? params.recs_per_page.toString() : '',
              current_page: params.current_page ? params.current_page.toString() : '',
              sort_field: params.sort_field ? params.sort_field : '',
              sort_order: params.sort_order ? params.sort_order : '',
              search_filter: params.search_filter ? JSON.stringify(params.search_filter) : ''
          }
        };

        if (options.params.sort_field == '') {
          delete options.params.sort_field;
        }

        if (options.params.sort_order == '') {
          delete options.params.sort_order;
        }

        return this.http.get(url, options);
    }
}


// WEBPACK FOOTER //
// /opt/sss_web/sss_web/src/app/service/loan.service.ts